module.exports = __webpack_public_path__ + "img/auth.7c85d0fb.jpg";